import qs from 'qs';
import {Session} from './components/Session';

/** creates an URL object from an endpoint and optional parameters */
export const newApiUrl = (endpoint: string, searchParams?: any): URL => {
  const url = new URL(`${process.env.REACT_APP_API_HOST}${endpoint}`);
  if (searchParams) {
    const str = qs.stringify(searchParams);
    url.search = str;
  }
  return url;
};

export const fetchApi = async (options: {
  session?: Session;
  url?: URL;
  endpoint?: string;
  headers?: RequestInit['headers'];
  method?: RequestInit['method'];
  body?: RequestInit['body'];
}): Promise<Response> => {
  const res = await fetch(
    options.url?.toString() ??
      `${process.env.REACT_APP_API_HOST}${options.endpoint}`,
    {
      headers: {
        Authorization: `Bearer ${options.session?.token ?? ''}`,
        'Content-Type': 'application/json; charset=utf-8',
        ...options.headers,
      },
      credentials: 'include',
      method: options.method,
      body: options.body,
    },
  );

  if (res.status === 401) {
    window.dispatchEvent(new Event('unauthorized'));
  }

  return res;
};

export type StoreType =
  | 'intersonProtac'
  | 'surdifuse'
  | 'emboutFrancais'
  | 'accessoire';

export const getLoginUrl = async (
  type: StoreType,
  session: Session,
): Promise<string> => {
  const res = await fetchApi({
    session,
    url: newApiUrl(`/common/session/getLoginToken/${type}`),
  });

  return (await res.json()).url;
};

export const openLoginUrl = async (
  type: StoreType,
  session: Session,
): Promise<void> => {
  const url = await getLoginUrl(type, session);
  if (!url) return;

  Object.assign(document.createElement('a'), {
    target: '_blank',
    href: url,
    rel: 'norel noopener',
  }).click();
};

export const openOrderUrl = async (
  ID: string,
  type: StoreType,
  session: Session,
): Promise<void> => {
  const url = await getLoginUrl(type, session);
  if (!url) return;

  Object.assign(document.createElement('a'), {
    target: '_blank',
    href: `${url}?action=viewOrder&ID=${ID}`,
    rel: 'norel noopener',
  }).click();
};
